import { useState } from "react";
import { Link } from "react-router-dom";
const CheckoutSteps = ({ currentStep }) => {
  const [count, setCount] = useState(currentStep);
  const steps = [
    { name: "Cart", link: "/cart" },
    { name: "Address", link: "/address" },
    { name: "Payment", link: "/payment" },
    { name: "Summary", link: "/summary" }
  ];
  return (
    <ul className="checkout-steps">
      {steps.map((step, index) => (
        <li
          key={step.name}
          className={`px-3 py-2 rounded ${index <= count ? "active" : "bg-gray-200 text-gray-700"
            }`}
        >
          <Link to={`${step.link.toLowerCase()}`} onClick={() => setCount(index)}>{step.name}</Link>
        </li>
      ))
      }
    </ul >
  );
};

export default CheckoutSteps;